// extracted by mini-css-extract-plugin
module.exports = {"cmczoq2":"cmczoq2"};